<template>
  <div class="flex flex-col h-screen">
    <NavbarComponent />

    <main class="mt-20 grow">
      <section class="px-4 md:px-20 mb-20">
        <div
          class="max-w-4xl mx-auto bg-white rounded-md shadow-md p-6 md:p-10"
        >
          <h1 class="text-3xl md:text-4xl font-semibold text-gray-900 mb-6">
            Information om cookies
          </h1>

          <p class="text-gray-800 mb-6">
            Här informerar vi om hur Golfigo använder cookies och liknande
            tekniker i enlighet med dataskyddsförordningen (GDPR) och lagen om
            elektronisk kommunikation.
          </p>

          <h2 class="text-2xl font-semibold text-gray-900 mb-3">
            Vad är cookies?
          </h2>
          <p class="text-gray-800 mb-6">
            Cookies är små textfiler som lagras lokalt i din webbläsare när du
            besöker en webbplats. De används för att webbplatsen ska fungera
            tekniskt, samt för att komma ihåg dina val och inställningar.
            Cookies kan vara antingen sessionscookies (som raderas när du
            stänger webbläsaren) eller permanenta cookies (som sparas under en
            längre tid).
          </p>

          <h2 class="text-2xl font-semibold text-gray-900 mb-3">
            Syfte med vår användning av cookies
          </h2>
          <p class="text-gray-800 mb-6">
            Golfigo använder cookies uteslutande för att säkerställa tjänstens
            grundläggande funktionalitet och säkerhet. Cookies möjliggör
            autentisering och session management så att du kan förbli inloggad
            under ditt besök. De används även för säkerhetsåtgärder, bland annat
            för att förhindra cross-site request forgery-attacker (CSRF-skydd).
            Vi använder inte cookies för marknadsföring, beteendeanalys,
            profilering eller tredjepartsspårning.
          </p>

          <h2 class="text-2xl font-semibold text-gray-900 mb-3">
            Förstaparts- och tredjepartscookies
          </h2>
          <p class="text-gray-800 mb-6">
            Förstapartscookies sätts direkt av den webbplats du besöker
            (golfigo.se) och kan endast läsas av denna webbplats.
            Tredjepartscookies sätts av externa tjänsteleverantörer, såsom
            analysverktyg, annonsnätverk eller sociala medier, via innehåll som
            laddas in på webbplatsen. Golfigo använder enbart förstapartscookies
            som är tekniskt nödvändiga för tjänstens funktion.
          </p>

          <h2 class="text-2xl font-semibold text-gray-900 mb-3">
            Vilka cookies använder vi?
          </h2>
          <p class="text-gray-800 mb-6">
            Golfigo använder två förstapartscookies som är tekniskt nödvändiga:
            (1) en sessionscookie som upprätthåller din autentisering och håller
            dig inloggad under hela din session, och (2) en CSRF-skyddscookie
            som förhindrar obehörig användning och säkerställer att
            förfrågningar till tjänsten kommer från dig och inte från tredje
            part. Båda cookies är strikt nödvändiga för att tjänsten ska fungera
            säkert och korrekt.
          </p>

          <h2 class="text-2xl font-semibold text-gray-900 mb-3">
            Samtycke och dina val
          </h2>
          <p class="text-gray-800">
            Enligt lagen om elektronisk kommunikation krävs inte samtycke för
            cookies som är strikt nödvändiga för att tillhandahålla en tjänst
            som du uttryckligen har begärt. Eftersom Golfigo enbart använder
            sådana tekniskt nödvändiga förstapartscookies, finns det för
            närvarande inga valfria cookies att acceptera eller neka. Om vi i
            framtiden skulle införa icke-nödvändiga cookies, exempelvis för
            analys eller marknadsföring, kommer vi att inhämta ditt samtycke
            innan dessa används, i enlighet med gällande lagstiftning.
          </p>
        </div>
      </section>
    </main>

    <FooterComponent />
  </div>
</template>

<script>
import NavbarComponent from "./components/Navbar.vue";
import FooterComponent from "./components/Footer.vue";

export default {
  name: "CookiesPage",
  components: { NavbarComponent, FooterComponent },
};
</script>

<style lang="scss" scoped></style>
